<template>
    <div>
        <!-- Variant Treatments-->

        <span style="width:100%;" v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
            <NavBar_Variant v-bind:item="item"></NavBar_Variant>
            <Results_ClinicalSignificance v-bind:item="item"></Results_ClinicalSignificance>

            <Loading v-model:active="isLoading" v-model="fullPage"
            :can-cancel="true"
            :is-full-page="fullPage" />
        </span>
    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import NavBar_Variant from '@/components/navbars/NavBar_Variant';
import Results_ClinicalSignificance from '@/components/query_result_components/Results_ClinicalSignificance.vue';
import active_variants from "@/methods/active_variants";

export default {
    name: 'VariantTreatments',
    components: {
        Loading,
        NavBar_Variant,
        Results_ClinicalSignificance
    },
    data: function() {
        return {
            isLoading: false,
            fullPage: true,
        }
    },
    created: async function() {
        this.isLoading=true
        active_variants.loadActiveBiomarkerSNV(this.$route.params.id)
        this.isLoading=false
    }
}
</script>
<style>
</style>
